import { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { useBrands } from "../utils/useBrands";
import { matchesBrandNameOrId } from "../utils/helpersOfBrands";
import NeedsConfigurationChart from "./NeedsConfigurationChart";
import NeedsConfigurationFilterCard from "./NeedsConfigurationFilterCard";
import NeedsConfigurationTable from "./NeedsConfigurationTable";

// Tab entry for "Needs Configuration" — rows with is_needs_configuration=1.
// No checkbox column, no primary action button, no reference line — a donut
// chart replaces it, per spec.
const NeedsConfiguration = () => {
  const { allBrandsData } = useBrands();

  const rows = useMemo(
    () => (allBrandsData || []).filter((row: any) => row?.is_needs_configuration === 1),
    [allBrandsData],
  );

  const [brandNameQuery, setBrandNameQuery] = useState("");
  const [selectedAffiliateSystem, setSelectedAffiliateSystem] = useState<string[] | null>(null);
  const [selectedCompany, setSelectedCompany] = useState<string[] | null>(null);
  const [selectedWebsite, setSelectedWebsite] = useState<string[] | null>(null);
  const [selectedStuckAt, setSelectedStuckAt] = useState<string[] | null>(null);
  const [selectedReason, setSelectedReason] = useState<string[] | null>(null);

  const filteredRows = useMemo(() => {
    return rows.filter((row: any) => {
      const brandNameMatch = matchesBrandNameOrId(row, brandNameQuery);
      const affiliateSystemMatch =
        !selectedAffiliateSystem?.length ||
        selectedAffiliateSystem.includes(row.affiliate_system);
      const companyMatch =
        !selectedCompany?.length || selectedCompany.includes(row.company_name);
      const websiteMatch =
        !selectedWebsite?.length || selectedWebsite.includes(row.website_name);
      const stuckAtMatch =
        !selectedStuckAt?.length || selectedStuckAt.includes(row.stuck_step);
      const reasonMatch = !selectedReason?.length || selectedReason.includes(row.reason);
      return (
        brandNameMatch &&
        affiliateSystemMatch &&
        companyMatch &&
        websiteMatch &&
        stuckAtMatch &&
        reasonMatch
      );
    });
  }, [
    rows,
    brandNameQuery,
    selectedAffiliateSystem,
    selectedCompany,
    selectedWebsite,
    selectedStuckAt,
    selectedReason,
  ]);

  const clearFilters = () => {
    setBrandNameQuery("");
    setSelectedAffiliateSystem(null);
    setSelectedCompany(null);
    setSelectedWebsite(null);
    setSelectedStuckAt(null);
    setSelectedReason(null);
  };

  return (
    <Box>
      <NeedsConfigurationFilterCard
        rows={rows}
        brandNameQuery={brandNameQuery}
        setBrandNameQuery={setBrandNameQuery}
        selectedAffiliateSystem={selectedAffiliateSystem}
        setSelectedAffiliateSystem={setSelectedAffiliateSystem}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        selectedWebsite={selectedWebsite}
        setSelectedWebsite={setSelectedWebsite}
        selectedStuckAt={selectedStuckAt}
        setSelectedStuckAt={setSelectedStuckAt}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        clearFilters={clearFilters}
      />

      <Box sx={{ mt: 2 }}>
        <NeedsConfigurationChart rows={rows} />
      </Box>

      <NeedsConfigurationTable rows={filteredRows} />
    </Box>
  );
};

export default NeedsConfiguration;
